import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { scrollToId } from "@/lib/motion";

export const MobileBar = () => {
  const [formVisible, setFormVisible] = useState(false);
  useEffect(() => {
    const on = () => {
      const el = document.getElementById("richiedi");
      if (!el) return;
      const r = el.getBoundingClientRect();
      setFormVisible(r.top < window.innerHeight - 40 && r.bottom > 40);
    };
    on();
    window.addEventListener("scroll", on, { passive: true });
    window.addEventListener("resize", on);
    return () => { window.removeEventListener("scroll", on); window.removeEventListener("resize", on); };
  }, []);
  const show = !formVisible;
  return (
    <div
      className={`fixed inset-x-0 bottom-0 z-40 border-t border-[#E7E5DF] bg-[#F7F6F2]/90 p-3 backdrop-blur-xl transition-transform duration-500 lg:hidden ${show ? "translate-y-0" : "translate-y-full"}`}
      style={{ paddingBottom: "max(12px, env(safe-area-inset-bottom))" }}
      aria-hidden={!show}
      data-testid="mobile-cta-bar"
      data-visible={show}
    >
      <a href="#richiedi" tabIndex={show ? 0 : -1} onClick={(e) => { e.preventDefault(); scrollToId("richiedi"); }} className="rl-btn rl-btn-amber w-full" data-testid="mobile-cta-button">
        Richiedi una figura <ArrowRight size={16} />
      </a>
    </div>
  );
};
